import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { config } from '@app/core/app-config';
import { NotificationType } from '@app/shared/interfaces';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { UserManagementService } from '@app/shared/services/user-management/user-management.service';

@Component({
  standalone: false,
  selector: 'sbnb-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss'],
})
export class InviteComponent implements OnInit {
  token: string;
  inviteDetails: any;
  loading: boolean;
  error: boolean;
  saving: boolean;
  newPassword: string;
  newPassword2: string;

  config = config;

  constructor(
    private route: ActivatedRoute,
    private userMgtService: UserManagementService,
    private toast: ToastNotificationsService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.route.params.subscribe((params) => {
      this.token = params['token'];
      this.getInviteDetails();
    });
  }

  getInviteDetails() {
    this.userMgtService.getInviteDetails(this.token).subscribe((res: any) => {
      if (res.error) {
        this.error = true;

        this.loading = false;
      } else {
        this.inviteDetails = res;

        if (this.inviteDetails.active) {
          this.acceptInvitation();
        } else {
          this.loading = false;
        }
      }
    });
  }

  setPasswordClicked() {
    if (this.newPassword !== this.newPassword2) {
      this.toast.open(`Hey! Your passwords don't seem to match!`, 'Dismiss', NotificationType.Error);

      return;
    }

    this.saving = true;

    this.acceptInvitation();
  }

  acceptInvitation() {
    this.userMgtService
      .acceptInviteAndSetPassword(this.token, this.inviteDetails.email, this.newPassword)
      .subscribe((res: any) => {
        if (res && res.error) {
          this.loading = false;
          this.saving = false;
          return;
        }
      });
  }
}
